import { ArrowUpDown, ArrowUp, ArrowDown } from "lucide-react";
import type { SortDirection, SortField } from "./ClassificationRuleUtils";

interface ClassificationRulesTableHeaderProps {
  sortField: SortField;
  sortDirection: SortDirection;
  onSort: (field: SortField) => void;
}

function SortIcon({
  field,
  currentField,
  direction,
}: {
  field: SortField;
  currentField: SortField;
  direction: SortDirection;
}) {
  if (currentField !== field) {
    return <ArrowUpDown className="ml-1 h-4 w-4 text-ink-400" />;
  }
  return direction === "asc" ? (
    <ArrowUp className="ml-1 h-4 w-4 text-ink-600" />
  ) : (
    <ArrowDown className="ml-1 h-4 w-4 text-ink-600" />
  );
}

export function ClassificationRulesTableHeader({
  sortField,
  sortDirection,
  onSort,
}: ClassificationRulesTableHeaderProps) {
  return (
    <thead>
      <tr className="border-b border-grid-200 bg-grid-50">
        <th className="px-6 py-4 text-left">
          <button
            onClick={() => onSort("category")}
            className="flex items-center text-xs font-semibold uppercase tracking-wider text-ink-600 hover:text-ink-900"
          >
            Rule category
            <SortIcon
              field="category"
              currentField={sortField}
              direction={sortDirection}
            />
          </button>
        </th>
        <th className="px-6 py-4 text-left">
          <button
            onClick={() => onSort("targets")}
            className="flex items-center text-xs font-semibold uppercase tracking-wider text-ink-600 hover:text-ink-900"
          >
            Dashboard column
            <SortIcon
              field="targets"
              currentField={sortField}
              direction={sortDirection}
            />
          </button>
        </th>
        <th className="px-6 py-4 text-left">
          <button
            onClick={() => onSort("value")}
            className="flex items-center text-xs font-semibold uppercase tracking-wider text-ink-600 hover:text-ink-900"
          >
            Value
            <SortIcon
              field="value"
              currentField={sortField}
              direction={sortDirection}
            />
          </button>
        </th>
        <th className="px-6 py-4 text-left">
          <button
            onClick={() => onSort("weight")}
            className="flex items-center text-xs font-semibold uppercase tracking-wider text-ink-600 hover:text-ink-900"
          >
            Weight
            <SortIcon
              field="weight"
              currentField={sortField}
              direction={sortDirection}
            />
          </button>
        </th>
        <th className="px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider text-ink-600">
          Keywords
        </th>
        <th className="px-6 py-4 text-left">
          <button
            onClick={() => onSort("isActive")}
            className="flex items-center text-xs font-semibold uppercase tracking-wider text-ink-600 hover:text-ink-900"
          >
            Active
            <SortIcon
              field="isActive"
              currentField={sortField}
              direction={sortDirection}
            />
          </button>
        </th>
        <th className="px-6 py-4 text-right text-xs font-semibold uppercase tracking-wider text-ink-600">
          Actions
        </th>
      </tr>
    </thead>
  );
}
